<script lang="ts" setup>
import { PaxSelectorView } from '@apps/main/new-desktop/modules/paxSelector';

import type { Pax } from '@libs/trip-planner-interfaces';

import type { ConfigurationPanelPaxDetails } from '../../../models/configurationPanel.model';

interface PaxTabProps {
  paxDetails: ConfigurationPanelPaxDetails;
}

const props = defineProps<PaxTabProps>();

interface PaxTabEmits {
  (event: 'update-pax', newPax: Pax): void;
}

const emit = defineEmits<PaxTabEmits>();
</script>

<template>
  <PaxSelectorView
    :initial-paxes="props.paxDetails.initialPaxes"
    :should-show-tickets-warning="props.paxDetails.shouldShowTicketsWarning"
    :should-show-room-selection-warning="
      props.paxDetails.shouldShowRoomSelectionWarning
    "
    :emit-debounce-time-ms="1000"
    @update-pax="emit('update-pax', $event)"
  />
</template>
